declare namespace $ {

	export class $bog_builderui_skeleton extends $bog_builderui_div {
		attr( ): ({ 
			'mol_view_error': string,
		}) 
	}
	
}

//# sourceMappingURL=skeleton.view.tree.d.ts.map